import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Facebook, Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0a0a0a] text-white">
      {/* Main footer */}
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company info */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_adm-confort-clim/artifacts/b6cwxb4j_PHOTO-2026-03-15-22-05-58-removebg-preview%20%281%29.png"
                alt="ADM Confort Clim - Logo"
                className="h-12 w-auto bg-white rounded-lg p-1"
              />
              <div>
                <span className="font-outfit font-bold text-xl">ADM Confort Clim</span>
              </div>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Spécialiste en climatisation, pompe à chaleur, froid commercial et ventilation. 
              13 ans d'expérience au service de votre confort. Basés en Seine-et-Marne, nous intervenons partout en France.
            </p>
            <div className="flex items-center gap-3">
              <a 
                href="#" 
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#1997b0] transition-colors"
                aria-label="Facebook"
                data-testid="footer-facebook"
              >
                <Facebook size={18} />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#1997b0] transition-colors"
                aria-label="LinkedIn"
                data-testid="footer-linkedin"
              >
                <Linkedin size={18} />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#1997b0] transition-colors"
                aria-label="Instagram"
                data-testid="footer-instagram"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-outfit font-semibold text-lg mb-6">Nos Services</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="text-slate-400 hover:text-[#1997b0] transition-colors text-sm" data-testid="footer-service-clim">
                  Climatisation
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-[#1997b0] transition-colors text-sm" data-testid="footer-service-pac">
                  Pompe à chaleur
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-[#1997b0] transition-colors text-sm" data-testid="footer-service-froid">
                  Froid commercial
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-[#1997b0] transition-colors text-sm" data-testid="footer-service-ventil">
                  Ventilation
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-[#fabc63] transition-colors text-sm font-medium" data-testid="footer-service-urgence">
                  Dépannage urgent 24h/24
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick links */}
          <div>
            <h3 className="font-outfit font-semibold text-lg mb-6">Liens Utiles</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-slate-400 hover:text-[#1997b0] transition-colors text-sm" data-testid="footer-link-home">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/a-propos" className="text-slate-400 hover:text-[#1997b0] transition-colors text-sm" data-testid="footer-link-about">
                  À propos
                </Link>
              </li>
              <li>
                <Link to="/realisations" className="text-slate-400 hover:text-[#1997b0] transition-colors text-sm" data-testid="footer-link-realisations">
                  Nos réalisations
                </Link>
              </li>
              <li>
                <Link to="/zone-intervention" className="text-slate-400 hover:text-[#1997b0] transition-colors text-sm" data-testid="footer-link-zones">
                  Zone d'intervention
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-[#1997b0] transition-colors text-sm" data-testid="footer-link-contact">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/mentions-legales" className="text-slate-400 hover:text-[#1997b0] transition-colors text-sm" data-testid="footer-link-mentions">
                  Mentions légales
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact info */}
          <div>
            <h3 className="font-outfit font-semibold text-lg mb-6">Contact</h3>
            <ul className="space-y-4">
              <li>
                <a 
                  href="tel:0603054911" 
                  className="flex items-start gap-3 text-slate-400 hover:text-[#fabc63] transition-colors group"
                  data-testid="footer-phone"
                >
                  <Phone size={18} className="text-[#1997b0] mt-0.5 flex-shrink-0" />
                  <div>
                    <span className="text-sm block">06 03 05 49 11</span>
                    <span className="text-xs text-[#fabc63]">Urgence 24h/24</span>
                  </div>
                </a>
              </li>
              <li>
                <a 
                  href="mailto:admconfortclim@gmail.com" 
                  className="flex items-start gap-3 text-slate-400 hover:text-[#1997b0] transition-colors"
                  data-testid="footer-email"
                >
                  <Mail size={18} className="text-[#1997b0] mt-0.5 flex-shrink-0" />
                  <span className="text-sm">admconfortclim@gmail.com</span>
                </a>
              </li>
              <li>
                <div className="flex items-start gap-3 text-slate-400">
                  <MapPin size={18} className="text-[#1997b0] mt-0.5 flex-shrink-0" />
                  <span className="text-sm">
                    209 rue de Changis<br />
                    77550 Moissy-Cramayel
                  </span>
                </div>
              </li>
              <li>
                <div className="flex items-start gap-3 text-slate-400">
                  <Clock size={18} className="text-[#1997b0] mt-0.5 flex-shrink-0" />
                  <div className="text-sm">
                    <span className="block">Lun - Ven : 8h - 19h</span>
                    <span className="text-[#fabc63]">Urgences : 24h/24 - 7j/7</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-slate-500">
            <div>
              <p>© {currentYear} ADM Confort Clim. Tous droits réservés.</p>
              <p className="text-xs text-slate-600 mt-1">SIRET : 94406926900016</p>
            </div>
            <div className="flex items-center gap-6">
              <Link to="/mentions-legales" className="hover:text-[#1997b0] transition-colors" data-testid="footer-bottom-mentions">
                Mentions légales
              </Link>
              <span className="text-slate-700">|</span>
              <span>Siège : Seine-et-Marne (77) • Intervention France entière</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
